
import React, { Component } from 'react';
import { Button, Input, Modal } from 'reactstrap';
import { IoIosAddCircleOutline, IoIosRemoveCircleOutline } from "react-icons/io";
import { RiDeleteBin5Line } from "react-icons/ri";
import ModifierComponent from './modifierComponent';
import SubModifierComponent from './subModifierComponent';

const stateManager = require('../../../../utils/state/stateManager.js');
const formatter = require('../../../../utils/formatter/formatter.js');
const modelUtil = require('../../../../utils/basket/modelUtil.js');
const localizationUtils = require('../../../../utils/localization/localizationUtils');

class ItemComponent extends Component 
{
    constructor(props)
    {
        super(props);
        this.closeModal =this.closeModal.bind(this);

        this.state = {};
        this.state.itemModel = {};
        this.state.itemModel.menu = stateManager.getStore().getState().currentMenu;
        this.state.itemModel.category = this.state.itemModel.menu.categories[this.props.categoryIndex];
        this.state.itemModel.item = this.state.itemModel.category.items[this.props.itemIndex];
        
        this.state.itemModel.kitchenNotes = "";
        this.state.itemModel.quantity = 1;

        this.state.itemModel.modifierGroupModels = [];
        for (var index = 0; index < this.state.itemModel.item.modifiers.length; index++)
        {
            var modifierGroupModel = {};
            modifierGroupModel.modifier = this.state.itemModel.item.modifiers[index];
            modifierGroupModel.modifierModels = [];
            this.state.itemModel.modifierGroupModels.push(modifierGroupModel);
            this.setupModifier(modifierGroupModel);
        }

        this.state.selectedModifierModel = null;
    }

    setupModifier(modifierGroupModel)
    {
        for (var index = 0; index < modifierGroupModel.modifier.items.length; index++)
        {
            var subItemModel = {};
            subItemModel.modifier = modifierGroupModel.modifier.items[index];
            subItemModel.quantity = 0;
            subItemModel.modifierGroupModels = [];
            modifierGroupModel.modifierModels.push(subItemModel);

            if (modifierGroupModel.modifier.items.length == 1 &&
                modifierGroupModel.modifier.min == 1 && 
                modifierGroupModel.modifier.max == 1)
                subItemModel.quantity = 1;

            for (var subIndex = 0; subIndex < subItemModel.modifier.modifiers.length; subIndex++)
            {
                var subModifierGroupModel = {};
                subModifierGroupModel.modifier = subItemModel.modifier.modifiers[subIndex];
                subModifierGroupModel.modifierModels = [];
                subItemModel.modifierGroupModels.push(subModifierGroupModel);
                this.setupModifier(subModifierGroupModel);
                
            }
        }
    }
    
    render()
    {
        if (this.state.selectedModifierModel != null)
                return <ModifierComponent 
                            modifierModel={this.state.selectedModifierModel} 
                            itemModel={this.state.itemModel}
                            onDismiss={()=>
                                        {
                                            if (!modelUtil.isItemModelFullySatisfied(this.state.selectedModifierModel))
                                            {
                                                modelUtil.removeItemModel(this.state.selectedModifierModel);
                                            }

                                            this.state.selectedModifierModel = null;
                                            this.setState({});
                                        }}/>

        return  <Modal isOpen={true} centered>
                    <div>
                        <div style={{ overflowY: 'scroll', maxHeight: `80vh`, overflowX:'crop'}}>
                            {this.renderHeader()}
                            
                            {this.renderModifiers()}
                            {this.renderKitchenNotes()}
                            <div className='mb-4'>
                                {this.renderQuantityComponent()}
                            </div>
                        </div>
                        {this.renderButtons()}
                    </div>
                </Modal>        
    }

    renderHeader()
    {
        return (<div>

                    <div style={{ zIndex: '5000', background:`var(--menu-item-header-color)`, width:'100%'}}>
                        <div style={{paddingLeft:'10px', paddingRight:'10px',paddingTop:'5px', position:'sticky'}}>
                                <h4 style={{fontWeight:'bold', marginBottom:'0px'}}>{this.state.itemModel.item.caption}</h4>
                                <div className='smallText'>{this.state.itemModel.item.notes}</div>
                        </div>
                
                        <hr style={{marginTop:'5px', marginBottom:'0px'}}/> 
                    </div>
                    
                </div>);
    }

    renderModifiers()
    {
        var childComponents = [];
        for (var index = 0; index < this.state.itemModel.modifierGroupModels.length; index++)
        {
            this.renderModifier(this.state.itemModel.modifierGroupModels[index], childComponents);
        }

        return  <div>
                    {childComponents}
                </div>
    }

    renderModifier(modifierGroupModel, childComponents)
    {
        if (modifierGroupModel.modifier.items.length == 1 &&
            modifierGroupModel.modifier.min == 1 && 
            modifierGroupModel.modifier.max == 1)
            return;

        childComponents.push(<div style={{background:`var(--menu-modifier-background-color)`, 
                                          color:`var(--menu-modifier-font-color)`, 
                                          fontSize:`var(--menu-modifier-font-size)`, 
                                          paddingLeft:'10px',
                                          paddingRight:'10px',
                                          paddingTop:'20px',
                                          paddingBottom:'20px',
                                          fontWeight:'bold',
                                          }}>
                                {modifierGroupModel.modifier.caption}
                             </div>)

        for (var index = 0; index < modifierGroupModel.modifierModels.length; index++)
        {
            this.renderModifierItem(modifierGroupModel, modifierGroupModel.modifierModels[index], childComponents);
        }
    }

    renderModifierItem(modifierGroupModel, modifierModel, childComponents)
    {
        var style = {};
        style.display = 'inline';
        var disabled = false;

        if (modifierModel.modifier.isSnoozed)
            disabled = true;

        if (modifierModel.quantity <= 0 && !modelUtil.canSelectMoreModifiers(modifierGroupModel))
            disabled = true;

        if (disabled)
            style.color = `var(--muted-text-color)`;

        var selectedQuantity = null;
        var deleteIcon = null;
        if (modifierModel.quantity > 0)
        {
            deleteIcon = <span style={{marginLeft:'5px', marginRight:'40px'}}
                               onClick={(event)=>
                               {
                                    modifierModel.quantity = 0;
                                    this.setState({});
                                    event.stopPropagation();
                               }} >
                            <RiDeleteBin5Line size={20}/>
                        </span>
            if (modifierModel.quantity > 1)
                selectedQuantity = <span style={{borderLeft:`var(--selected-modifier-item-border)`, marginRight:'5px'}}>
                                        <h4 style={{marginLeft:'2px', 
                                                    display: 'inline',
                                                    color: `var(--selected-modifier-quantity-font-color)`}}>{modifierModel.quantity}x</h4>
                                    </span>
            else
                selectedQuantity = <span style={{borderLeft:`var(--selected-modifier-item-border)`, marginRight:'5px'}}>
                                    </span>
        }

        var subModifierComponent = null;
        if (modifierModel.quantity > 0 && modifierModel.modifierGroupModels.length > 0)
            subModifierComponent = <SubModifierComponent modifierModel={modifierModel}
                                        onEditSelection={()=>
                                        {
                                            this.state.selectedModifierModel = modifierModel;
                                            this.setState({});
                                        }}/>

        childComponents.push(
                                <div style={{
                                                paddingLeft:'20px', 
                                                paddingRight:'20px',
                                                paddingTop:'8px', 
                                                paddingBottom:'8px'}}
                                                
                                    onClick={()=>
                                        {
                                            if (disabled || !modelUtil.canSelectMoreModifiers(modifierGroupModel))
                                                return;

                                            if (modifierGroupModel.quantity > 0 && !modelUtil.multipleSelectionAllowedInModifierGroupModel(modifierGroupModel))
                                                return;

                                            modifierModel.quantity = modifierModel.quantity + 1;
                                            if (modifierModel.quantity == 1 && modifierModel.modifierGroupModels.length > 0)
                                            {
                                                this.state.selectedModifierModel = modifierModel;
                                            }
                                            this.setState({});
                                        }}>

                                    
                                    <table>
                                        <tr>
                                            <td style={{width:'99%'}}>
                                                {selectedQuantity}<h4 style={style}>{modifierModel.modifier.caption}</h4>
                                                
                                            </td>
                                            <td>
                                                {deleteIcon}
                                            </td>
                                            <td>
                                                <h4 style={style}> {formatter.convertToCurrencyFormat(modifierModel.modifier.price)}</h4>
                                            </td>
                                        </tr>
                                    </table>
                                    {subModifierComponent}
                                </div>
        )
    }

    renderKitchenNotes()
    {
        return <div style={{marginLeft:'10px', marginRight:'10px', marginTop:'30px'}}>
                    <Input type="email" name="email" id="exampleEmail" placeholder="Add kitchen notes" 
                            onChange={(event) =>
                            {
                                this.state.itemModel.kitchenNotes = event.target.value;
                            }}/>
               </div>
    }

    renderQuantityComponent()
    {
        return <div style={{marginTop:'30px'}}>
                    <table style={{marginLeft:'auto', marginRight:'auto'}}>
                        <tr style={{textAlign:'center'}}>
                            <td>
                                <div>
                                    <IoIosAddCircleOutline size={45} 
                                            onClick={()=>{
                                                            if (this.state.itemModel.quantity > 30)
                                                                return;
                                                                
                                                            this.state.itemModel.quantity = this.state.itemModel.quantity + 1;
                                                            this.setState({});
                                                         }}/>
                                </div>
                                
                            </td>
                            <td>
                                <div style={{marginLeft:'20px', marginRight:'20px', fontSize:`var(--counter-btn-font-size)`}}>
                                    {this.state.itemModel.quantity}
                                </div>
                            </td>
                            <td>
                                <IoIosRemoveCircleOutline size={45} 
                                            onClick={()=>{
                                                            if (this.state.itemModel.quantity == 1)
                                                                return;
                                                                
                                                            this.state.itemModel.quantity = this.state.itemModel.quantity - 1;
                                                            this.setState({});
                                                         }}/>
                            </td>
                        </tr>
                    </table>
                    
               </div>
    }

    renderButtons()
    {
        return  <div style={{
                                textAlign:'center', 
                                width:'100%',
                                paddingBottom:'20px', 
                                paddingTop:'20px', 
                                borderTop:`var(--bottom-bar-top-border)`,
                                background:`var(--bottom-bar-background-color)`
                            }}>
                                 
                    <Button color="primary" 
                            style={{
                                        color:`var(--button-back-font-color)`, 
                                        background:`var(--button-back-background-color)`,
                                        borderColor:`var(--button-back-background-color)`,
                                        fontSize:`var(--button-back-font-size)`,
                                        fontWeight:'bold',
                                        marginRight:'5px',
                                        paddingLeft:'20px',
                                        paddingRight:'20px',
                                        paddingTop:'10px',
                                        paddingBottom:'10px'
                                    }}
                            onClick={()=>
                                     {
                                         this.closeModal();
                                     }}>Back</Button>{' '}
                    <Button color="primary" 
                            disabled={!modelUtil.isItemModelFullySatisfied(this.state.itemModel)}
                            style={{
                                        color:`var(--button-addToBasket-font-color)`, 
                                        background:`var(--button-addToBasket-background-color)`,
                                        borderColor:`var(--button-addToBasket-background-color)`,
                                        fontSize:`var(--button-addToBasket-font-size)`,
                                        fontWeight:'bold',
                                        marginRight:'5px',
                                        paddingLeft:'20px',
                                        paddingRight:'20px',
                                        paddingTop:'10px',
                                        paddingBottom:'10px',
                                    }}
                            onClick={()=>
                                {
                                    this.addToBasket();
                                }}>Add To Basket - {formatter.convertToCurrencyFormat(modelUtil.getItemModelTotalPrice(this.state.itemModel))}</Button>{' '}
                </div>
    }

    closeModal()
    {
        this.props.onClose(null)
    }

    addToBasket()
    {
        var orderItem = {}
        orderItem.productId = this.state.itemModel.item.productId;
        orderItem.caption = this.state.itemModel.item.caption;
        orderItem.category = this.state.itemModel.item.category;
        orderItem.unitPrice = this.state.itemModel.item.price;
        orderItem.unitPoints = 0.0;
        orderItem.quantity = this.state.itemModel.quantity;
        orderItem.vat = this.calculateTax(this.state.itemModel.item);
        orderItem.instructions = this.state.itemModel.kitchenNotes;
                            
        orderItem.backgroundColor = this.state.itemModel.item.backgroundColor; 
        orderItem.foregroundColor = this.state.itemModel.item.foregroundColor;
        orderItem.paramsJson = this.state.itemModel.item.paramsJson;
        orderItem.saleItems = [];

        this.addSubItems(orderItem, this.state.itemModel);
        this.props.onClose(orderItem);
    }

    addSubItems(parentItem, itemModel)
    {
        itemModel.modifierGroupModels.forEach (modifierGroupModel =>
        {
            modifierGroupModel.modifierModels.forEach(modifierModel =>
            {
                for (var index = 0; index < modifierModel.quantity; index++)
                {
                    var modifierOrderItem = {}
                    modifierOrderItem.productId = modifierModel.modifier.productId;
                    modifierOrderItem.caption = modifierModel.modifier.caption;
                    modifierOrderItem.category = modifierModel.modifier.category;
                    modifierOrderItem.unitPrice = modifierModel.modifier.price;
                    modifierOrderItem.unitPoints = 0.0
                    modifierOrderItem.quantity = parentItem.quantity;
                    modifierOrderItem.vat = this.calculateTax(modifierModel.modifier);
                    modifierOrderItem.foregroundColor = modifierModel.modifier.foregroundColor;
                    modifierOrderItem.backgroundColor = modifierModel.modifier.backgroundColor;
                    modifierOrderItem.paramsJson = modifierModel.modifier.paramsJson;
                    modifierOrderItem.saleItems = [];
                    
                    parentItem.saleItems.push(modifierOrderItem);
                    this.addSubItems(modifierOrderItem, modifierModel)
                }
            });
        });
    }

    calculateTax(saleItem)
    {
        if (!localizationUtils.isVatApplicable())
            return 0.0;

        if (localizationUtils.isVatInclusive())
            return formatter.roundUp(saleItem.taxablePrice - (saleItem.taxablePrice / (1 + saleItem.tax)), 2);
        else
            return formatter.roundUp(saleItem.taxablePrice * saleItem.tax, 2);
    }
}

export default ItemComponent;